import { EQUIPMENT, FOCUS_AREA } from 'utils/constants/categories';

import { LIMIT_AMOUNT_OF_VIDEOS } from 'utils/constants/limit-videos';
/* eslint-disable default-case */
import produce from 'immer';
import {
  clearFilters,
  deleteVideo,
  editVideo,
  getEquipments,
  getFocusAreas,
  getVideos,
  selectVideo,
  selectVideoCard,
  setDateRange,
  setPagination,
  setSearchVideosEquipment,
  setSearchVideosFocusArea,
  setSearchVideosTerm,
  uploadVideo,
} from './actions';

const initialState = {
  loading: false,
  videos: [],
  videosTotalAmount: 0,
  videosFetched: false,
  videosError: null,
  focusAreas: [],
  equipments: [],
  pagination: {
    startId: null,
    limit: LIMIT_AMOUNT_OF_VIDEOS,
    skip: 0,
    page: 1,
  },
  search: {
    term: '',
    equipment: null,
    focusArea: null,
    dateRange: {
      startDate: null,
      endDate: new Date(''),
      key: 'selection',
    },
  },
  videoCard: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case uploadVideo.TRIGGER:
      draft.loading = true;
      break;
    case uploadVideo.FULFILL:
      draft.loading = false;
      break;

    case selectVideo.TRIGGER:
      draft.loading = true;
      break;
    case selectVideo.FULFILL:
      draft.loading = false;
      break;

    case getVideos.TRIGGER:
      draft.loading = true;
      draft.videosError = null;
      break;
    case getVideos.SUCCESS:
      draft.videos = payload.results;
      draft.videosTotalAmount = payload.count;
      break;
    case getVideos.FAILURE:
      // Clear the list so a failure isn't mistaken for the previous results
      draft.videos = [];
      draft.videosTotalAmount = 0;
      draft.videosError = payload;
      break;
    case getVideos.FULFILL:
      draft.loading = false;
      draft.videosFetched = true;
      break;

    case editVideo.TRIGGER:
      draft.loading = true;
      break;
    case editVideo.FULFILL:
      draft.loading = false;
      break;

    case deleteVideo.TRIGGER:
      draft.loading = true;
      break;
    case deleteVideo.FULFILL:
      draft.loading = false;
      break;

    case getFocusAreas.TRIGGER:
      draft.loading = true;
      break;
    case getFocusAreas.SUCCESS:
      draft.focusAreas = payload;
      break;
    case getFocusAreas.FULFILL:
      draft.loading = false;
      break;
    case getEquipments.TRIGGER:
      draft.loading = true;
      break;
    case getEquipments.SUCCESS:
      draft.equipments = payload;
      break;
    case getEquipments.FULFILL:
      draft.loading = false;
      break;

    case setPagination.toString():
      draft.pagination = payload;
      break;
    case setSearchVideosTerm.toString():
      draft.pagination.startId = null;
      draft.pagination.skip = 0;
      draft.pagination.page = 1;
      draft.search.term = payload;
      break;
    case setSearchVideosEquipment.toString():
      draft.pagination.startId = null;
      draft.pagination.skip = 0;
      draft.pagination.page = 1;
      draft.search.equipment = payload === EQUIPMENT ? null : payload;
      break;
    case setSearchVideosFocusArea.toString():
      draft.pagination.startId = null;
      draft.pagination.skip = 0;
      draft.pagination.page = 1;
      draft.search.focusArea = payload === FOCUS_AREA ? null : payload;
      break;
    case selectVideoCard.toString():
      draft.videoCard = payload;
      break;
    case setDateRange.toString():
      draft.search.dateRange = payload;
      break;
    case clearFilters.toString():
      draft.pagination.startId = null;
      draft.pagination.skip = 0;
      draft.pagination.page = 1;

      draft.search.equipment = null;
      draft.search.focusArea = null;
      draft.search.term = '';
      draft.search.dateRange = {
        startDate: null,
        endDate: new Date(''),
        key: 'selection',
      };
      break;
  }
}, initialState);

export default reducer;
